import { MaterialEntradaService } from './../../services/material-entrada.service'

import { Component, OnInit } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { Util } from 'src/app/utils/util.util'
import { SCAMP_API } from 'src/environments/environment'

@Component({
  selector: 'app-entradas-periodo',
  templateUrl: './entradas-periodo.component.html',
  styleUrls: ['./entradas-periodo.component.scss'],
})
export class EntradasPeriodoComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private materialEntradaService: MaterialEntradaService,
  ) {}

  public inputDataInicial: HTMLInputElement
  public inputDataFinal: HTMLInputElement

  public isProcessing: boolean = false
  public maskData = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  public subtituloResultadoPesquisa = ''

  public validations = {
    inputDataInicialNotEmpty: true,
    inputDataFinalNotEmpty: true,
    inputDataInicialValid: true,
    inputDataFinalValid: true,
    dataFinalMaiordataInicial: true,

    allFieldsValids() {
      return (
        this.inputDataInicialValid &&
        this.inputDataFinalValid &&
        this.dataFinalMaiordataInicial &&
        this.inputDataInicialNotEmpty &&
        this.inputDataFinalNotEmpty
      )
    },

    resetAllValidations() {
      this.inputDataInicialValid = true
      this.inputDataFinalValid = true
      this.dataFinalMaiordataInicial = true
      this.inputDataInicialNotEmpty = true
      this.inputDataFinalNotEmpty = true
    },
  }

  public results: any[] = []

  ngOnInit() {
    this.inputDataInicial = document.querySelector('.inputDataInicial')
    this.inputDataFinal = document.querySelector('.inputDataFinal')
  }

  public submit() {
    if (this.allFieldsValids()) {
      this.isProcessing = true

      this.materialEntradaService
        .getMaterialEntradaPorPeriodo(this.getParameters())
        .subscribe(
          (response) => {
            this.setSubtituloResultadoPesquisa()

            this.results = response
            this.isProcessing = false

            if (this.results.length == 0) {
              this.toastr.warning(
                'A consulta não trouxe resultados com os parâmetros fornecidos',
              )
            }
          },
          (error) => {
            this.isProcessing = false
            this.toastr.error(`Erro ao tentar obter os emprestimos`)
            console.log(error)
          },
        )
    }
  }

  public allFieldsValids() {
    this.validations.inputDataInicialNotEmpty =
      this.inputDataInicial.value != ''
    this.validations.inputDataFinalNotEmpty = this.inputDataFinal.value != ''

    return this.validations.allFieldsValids()
  }

  public checkDataValidations() {
    this.resetDataValidations()

    const dataInicial = this.inputDataInicial.value
    const dataFinal = this.inputDataFinal.value

    if (dataInicial != '' && dataFinal != '') {
      this.validations.inputDataInicialValid = Util.validaData(dataInicial)
      this.validations.inputDataFinalValid = Util.validaData(dataFinal)

      if (
        this.validations.inputDataInicialValid &&
        this.validations.inputDataFinalValid
      ) {
        if (
          Date.parse(Util.formatarDataptBRToenUS(dataFinal)) <
          Date.parse(Util.formatarDataptBRToenUS(dataInicial))
        ) {
          this.validations.dataFinalMaiordataInicial = false
        }
      }
    } else {
      this.validations.inputDataInicialNotEmpty = dataInicial != ''
      this.validations.inputDataFinalNotEmpty = dataFinal != ''
    }
  }

  private resetDataValidations() {
    this.validations.inputDataInicialValid = true
    this.validations.inputDataFinalValid = true
    this.validations.dataFinalMaiordataInicial = true
    this.validations.inputDataInicialNotEmpty = true
    this.validations.inputDataFinalNotEmpty = true
  }

  getParameters() {
    return {
      dataInicial: Util.formatarDataptBRToenUS(this.inputDataInicial.value),
      dataFinal: Util.formatarDataptBRToenUS(this.inputDataFinal.value),
    }
  }

  setSubtituloResultadoPesquisa() {
    let periodo = `entre <b>${this.inputDataInicial.value}</b> e <b>${this.inputDataFinal.value}</b>`
    this.subtituloResultadoPesquisa = `Entrada materiais -  ${periodo}`
  }

  reset() {
    this.validations.resetAllValidations()
    this.results = []
    this.subtituloResultadoPesquisa = ''
  }

  exportarToExcel() {
    this.isProcessing = true
    this.materialEntradaService.exportarToExcel(this.getParameters()).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            const hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`
            window.open(hrefExcelFile, '_blank')
          } else {
            this.toastr.warning(response.msgErro)
          }
        } else {
          this.toastr.error(response.msgErro)
        }
        this.isProcessing = false
      },
      (err: any) => {
        this.toastr.error(
          'Ocorreu um erro ao tentar exportar Excel',
          'Erro de Conexão',
        )
        this.isProcessing = false
      },
      () => (this.isProcessing = false),
    )
  }
}
